import { default as indexes5CJOaCDZMeta } from "/app/src/pages/about/index.vue?macro=true";
import { default as indexkyd3YQK9kkMeta } from "/app/src/pages/account/change-password-confirm/index.vue?macro=true";
import { default as indexnPTlsyudi5Meta } from "/app/src/pages/account/email-verify/index.vue?macro=true";
import { default as indexcXD2GcGbZoMeta } from "/app/src/pages/contacts/index.vue?macro=true";
import { default as indexJGQIZzaJvhMeta } from "/app/src/pages/dictionary/[slug]/[letter]/index.vue?macro=true";
import { default as avtoryV8pLkmumONMeta } from "/app/src/pages/dictionary/[slug]/avtory.vue?macro=true";
import { default as ot_izdatelyacJkgyjlRLqMeta } from "/app/src/pages/dictionary/[slug]/ot_izdatelya.vue?macro=true";
import { default as ot_redkollegiia6tdNV9Zw6Meta } from "/app/src/pages/dictionary/[slug]/ot_redkollegii.vue?macro=true";
import { default as sokrashcheniyauD8zclSL7hMeta } from "/app/src/pages/dictionary/[slug]/sokrashcheniya.vue?macro=true";
import { default as index7mNIHYy4wQMeta } from "/app/src/pages/gallery/index.vue?macro=true";
import { default as indexxU1BrrLYlQMeta } from "/app/src/pages/gui/index.vue?macro=true";
import { default as indexdPwi6hPdMfMeta } from "/app/src/pages/index.vue?macro=true";
import { default as index92GNDBaGdHMeta } from "/app/src/pages/news/[code]/index.vue?macro=true";
import { default as indexagNvmiqZGiMeta } from "/app/src/pages/news/index.vue?macro=true";
import { default as index0anYxncBX1Meta } from "/app/src/pages/privacy-policy/index.vue?macro=true";
import { default as index2gRhQT9qIDMeta } from "/app/src/pages/search/index.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/app/src/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: "account-change-password-confirm",
    path: "/account/change-password-confirm",
    component: () => import("/app/src/pages/account/change-password-confirm/index.vue").then(m => m.default || m)
  },
  {
    name: "account-email-verify",
    path: "/account/email-verify",
    component: () => import("/app/src/pages/account/email-verify/index.vue").then(m => m.default || m)
  },
  {
    name: "contacts",
    path: "/contacts",
    component: () => import("/app/src/pages/contacts/index.vue").then(m => m.default || m)
  },
  {
    name: "dictionary-slug-letter",
    path: "/dictionary/:slug()/:letter()",
    component: () => import("/app/src/pages/dictionary/[slug]/[letter]/index.vue").then(m => m.default || m)
  },
  {
    name: "dictionary-slug-avtory",
    path: "/dictionary/:slug()/avtory",
    component: () => import("/app/src/pages/dictionary/[slug]/avtory.vue").then(m => m.default || m)
  },
  {
    name: "dictionary-slug-ot_izdatelya",
    path: "/dictionary/:slug()/ot_izdatelya",
    component: () => import("/app/src/pages/dictionary/[slug]/ot_izdatelya.vue").then(m => m.default || m)
  },
  {
    name: "dictionary-slug-ot_redkollegii",
    path: "/dictionary/:slug()/ot_redkollegii",
    component: () => import("/app/src/pages/dictionary/[slug]/ot_redkollegii.vue").then(m => m.default || m)
  },
  {
    name: "dictionary-slug-sokrashcheniya",
    path: "/dictionary/:slug()/sokrashcheniya",
    component: () => import("/app/src/pages/dictionary/[slug]/sokrashcheniya.vue").then(m => m.default || m)
  },
  {
    name: "gallery",
    path: "/gallery",
    component: () => import("/app/src/pages/gallery/index.vue").then(m => m.default || m)
  },
  {
    name: "gui",
    path: "/gui",
    component: () => import("/app/src/pages/gui/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "news-code",
    path: "/news/:code()",
    component: () => import("/app/src/pages/news/[code]/index.vue").then(m => m.default || m)
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/app/src/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/app/src/pages/privacy-policy/index.vue").then(m => m.default || m)
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/app/src/pages/search/index.vue").then(m => m.default || m)
  }
]